module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2294846969d0c338f497994872451eb7.png";